import Button from "../../../../../../components/bootstrap/Button";
import FormGroup from "../../../../../../components/bootstrap/forms/FormGroup";
import Input from "../../../../../../components/bootstrap/forms/Input";
import Popovers from "../../../../../../components/bootstrap/Popovers";
import Spinner from "../../../../../../components/bootstrap/Spinner";
import logo from "../../../../../../assets/img/logo_uget_black.png";
import TableCustomDelivery from "../../../../../../components/MyCustom/TableCustomDelivery";
import Money from "../../../../../../helpers/utils/money/money";

const ProductsBlock = ({
    categoriesData,
    loadingStatus,
    loadingPrices,
    loadingDeleteCategory,
    loadingDeleteProduct,
    onEditPrice,
    onEditDiscount,
    onSavePrice,
    onToggleStatus,
    onOpenComplements,
    onRequestDeleteCategory,
    onRequestDeleteProduct,
}) => {
    const columns = [
        {
            label: "Imagem",
            field: "image_url",
            format: (row) => (
                <>
                    {row.image_url ? (
                        <img src={row.image_url} alt="Imagem" width={54} height={54} />
                    ) : (
                        <img src={logo} alt="Imagem" width={60} height="auto" />
                    )}
                </>
            ),
        },
        { label: "Nome", field: "name" },
        { label: "Delivery Code", field: "delivery_code" },
        {
            label: "Preço Base",
            field: "ifoodPrice",
            format: (row) => (
                <FormGroup>
                    <Input
                        value={Money.centsToMaskMoney(row.ifoodPrice)}
                        onChange={(e) => onEditPrice(row.id, e.target.value)}
                        className="w-50"
                    />
                </FormGroup>
            ),
        },
        {
            label: "Valor com Desconto",
            field: "ifoodDiscount",
            format: (row) => (
                <FormGroup>
                    <Input
                        value={Money.centsToMaskMoney(row.ifoodDiscount)}
                        onChange={(e) => onEditDiscount(row.id, e.target.value)}
                        className="w-50"
                    />
                </FormGroup>
            ),
        },
        {
            label: "Status",
            format: (row) =>
                loadingStatus[row.id] ? (
                    <Spinner />
                ) : (
                    <Button isLink color={row.status ? "success" : "warning"} icon="Circle" onClick={() => onToggleStatus(row)}>
                        {row.status ? "Ativo" : "Desativado"}
                    </Button>
                ),
        },
        {
            label: "Ações",
            format: (row) => (
                <div className="d-flex gap-2">
                    <Popovers trigger="hover" title="Salvar Preço">
                        <Button
                            isLink
                            onClick={() => onSavePrice(row)}
                            icon={loadingPrices[row.id] ? "HourglassEmpty" : "save"}
                            disabled={loadingPrices[row.id]}
                        />
                    </Popovers>
                    <Popovers trigger="hover" title="Gerenciar complementos">
                        <Button isLink color="dark" icon="ViewList" onClick={() => onOpenComplements(row)} />
                    </Popovers>
                    <Popovers trigger="hover" title="Remover produto">
                        <Button
                            isLink
                            color="danger"
                            icon="Delete"
                            onClick={() => onRequestDeleteProduct(row)}
                            disabled={loadingDeleteProduct[row.id]}
                        />
                    </Popovers>
                </div>
            ),
        },
    ];

    return (
        <TableCustomDelivery
            columns={columns}
            categoriesData={categoriesData}
            categoryActions={(category) => (
                <Popovers trigger="hover" title="Remover categoria">
                    <Button
                        isLink
                        color="danger"
                        icon="Delete"
                        onClick={() => onRequestDeleteCategory(category)}
                        disabled={loadingDeleteCategory[category.categoryId]}
                    />
                </Popovers>
            )}
            fileName="Produtos-iFood"
        />
    );
};

export default ProductsBlock;
